import angular from 'angular';
import eventBus from 'pubsub-js';
import RecentRelationsService, { filterRelations } from '@/shared/services/RecentRelationsService';

angular
  .module('cloudX')
  .factory('recentRelationsSvc', ['flySvc', '$q', '$http', 'appUrls', recentRelationsSvc]);

function recentRelationsSvc(flySvc, $q, $http, appUrls) {
  let recentRelations = [];
  function showError(error) {
    flySvc.error(error.data.code, error.data.parameters);
  }

  function reloadRecentRelations() {
    return $http.get(`${appUrls.api}/api/relation/recent`).then(
      ({ data }) => {
        recentRelations = data;
        RecentRelationsService.set(recentRelations);
        return data;
      },
      error => {
        showError(error);
        return null;
      },
    );
  }

  // used to trigger recent relations from react-components
  var reloadRecentRelationsSubscription = function(msg, data) {
    reloadRecentRelations();
  };

  eventBus.subscribe('reloadRecentRelations', reloadRecentRelationsSubscription);

  return {
    reloadRecentRelations: reloadRecentRelations,
    get: function() {
      return recentRelations;
    },
    getFiltered: searchOptions => filterRelations(recentRelations, searchOptions),
  };
}
